import {
  createAddon,
  IAddon,
  registerOperationHandler,
  createDeferredOperationHandler
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItems';
import { waitForPageLoad } from '@ms/items-view/lib/private/operations/pageLoad';
import { driveAppsKeyFacet, driveAppsExtensionKeyFacet } from './models/keys/FileHandlerKeyFacet';
import { asModuleWithRetries } from '@ms/utilities-async/lib/decorators/asModuleLoad';

const loadFileHandlerGetItemsOperationHandler = asModuleWithRetries(
  // tslint:disable-next-line:max-line-length
  () => import(/* webpackChunkName: 'addon-graph-deferredoperations' */'./handlers/operations/fileHandler/getItemsOperationHandler'),
  {
    chunkName: 'addon-graph-deferredoperations'
  }
);

/**
 * @public
 */
export const graphFileHandlerAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {

    dispatch(registerOperationHandler(driveAppsKeyFacet, getItemsOperation)(
      createDeferredOperationHandler(async () => {
        await dispatch(waitForPageLoad());
        const {
          fileHandlerGetItemsOperationHandler
        } = await loadFileHandlerGetItemsOperationHandler();
        return fileHandlerGetItemsOperationHandler;
      })
    ));

    dispatch(registerOperationHandler(driveAppsExtensionKeyFacet, getItemsOperation)(
      createDeferredOperationHandler(async () => {
        await dispatch(waitForPageLoad());
        const {
          filehandlerPerExtensionGetItemsOperationHandler
        } = await loadFileHandlerGetItemsOperationHandler();
        return filehandlerPerExtensionGetItemsOperationHandler;
      })
    ));

  };

});
